var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/Tab.tsx
import { default as MuiTab } from "@mui/material/Tab";
import { jsx } from "react/jsx-runtime";
var Tab = (props) => {
  return /* @__PURE__ */ jsx(MuiTab, __spreadProps(__spreadValues({}, props), { disableRipple: true, disableFocusRipple: true, disableTouchRipple: true }));
};

// src/lib/TabContext.tsx
import { default as MuiTabContext } from "@mui/lab/TabContext";
import { jsx as jsx2 } from "react/jsx-runtime";
var TabContext = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx2(MuiTabContext, __spreadProps(__spreadValues({}, rest), { children }));
};

// src/lib/TabList.tsx
import { default as MuiTabList } from "@mui/lab/TabList";

// src/lib/Tabs.tsx
import { styled } from "@mui/material/styles";
import { default as MuiTabs } from "@mui/material/Tabs";
import { jsx as jsx3 } from "react/jsx-runtime";
var secondaryTabStyling = ({ theme }) => ({
  ".MuiTabs-indicator": {
    display: "none"
  },
  ".MuiTab-root": {
    borderTopLeftRadius: ".25rem",
    borderTopRightRadius: ".25rem",
    border: "1px solid",
    borderColor: "transparent",
    marginBottom: "-1px",
    "&:hover, &:hover.Mui-selected": {
      backgroundColor: theme.palette.action.hover
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      backgroundColor: "inherit",
      outlineOffset: "-2px"
    },
    "&.Mui-selected": {
      backgroundColor: theme.palette.background.paper,
      borderColor: theme.palette.divider,
      borderBottomColor: theme.palette.background.paper
    }
  }
});
var PrimaryTabs = styled(MuiTabs, {
  name: "MuiTabs",
  slot: "AvPrimary",
  overridesResolver: (props, styles) => styles.avPrimary
})({});
var SecondaryTabs = styled(MuiTabs, {
  name: "MuiTabs",
  slot: "AvSecondary",
  overridesResolver: (props, styles) => styles.avSecondary
})(secondaryTabStyling);
var Tabs = (_a) => {
  var _b = _a, { level = "primary" } = _b, rest = __objRest(_b, ["level"]);
  const LevelledTabs = level === "primary" ? PrimaryTabs : SecondaryTabs;
  return /* @__PURE__ */ jsx3(LevelledTabs, __spreadProps(__spreadValues({}, rest), { orientation: "horizontal", centered: false }));
};

// src/lib/TabList.tsx
import { styled as styled2 } from "@mui/material/styles";
import { jsx as jsx4 } from "react/jsx-runtime";
var PrimaryTabs2 = styled2(MuiTabList, {
  name: "MuiTabs",
  slot: "AvPrimary",
  overridesResolver: (props, styles) => styles.avPrimary
})({});
var SecondaryTabs2 = styled2(MuiTabList, {
  name: "MuiTabs",
  slot: "AvSecondary",
  overridesResolver: (props, styles) => styles.avSecondary
})(secondaryTabStyling);
var TabList = (_a) => {
  var _b = _a, { level = "primary" } = _b, rest = __objRest(_b, ["level"]);
  const LevelledTabs = level === "primary" ? PrimaryTabs2 : SecondaryTabs2;
  return /* @__PURE__ */ jsx4(LevelledTabs, __spreadProps(__spreadValues({}, rest), { orientation: "horizontal", centered: false }));
};

// src/lib/TabPanel.tsx
import { default as MuiTabPanel } from "@mui/lab/TabPanel";
import { jsx as jsx5 } from "react/jsx-runtime";
var TabPanel = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx5(MuiTabPanel, __spreadProps(__spreadValues({}, rest), { children }));
};
export {
  Tab,
  TabContext,
  TabList,
  TabPanel,
  Tabs
};
